/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_No_ChangesInputs */

const en_profile_no_changes = /** @type {(inputs: Profile_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes made`)
};

const es_profile_no_changes = /** @type {(inputs: Profile_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se realizaron cambios`)
};

/**
* | output |
* | --- |
* | "No changes made" |
*
* @param {Profile_No_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_no_changes = /** @type {((inputs?: Profile_No_ChangesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_No_ChangesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_no_changes(inputs)
	return en_profile_no_changes(inputs)
});